import React, { Component } from 'react';

import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button, ButtonIcon} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';

import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';

import * as api from '../../api/api';
import ReviewUpload from './ReviewUpload';
import ExcelTemplateUpload from './ExcelTemplateUpload';
import PdfReviewerUpload from './PdfReviewerUpload';

class MCReviewUpload extends Component{

  constructor(props) {
    super(props)
    this.state = {
      errorMsg: '',
      
      data:{
        mcCertTopicId: '',
        topicName:'',
        submissionDetails: []
      },

    };

    
  }

  componentDidMount() {
    //console.log('Inside MC Submission - mc_cert_topic_id '+ this.props.mcCertTopicId + ' ' + this.props.certType)
    let data = Object.assign({}, this.state.data)
    return api.fetchMCSubmissionDetails(this.props.user.accessToken, this.props.mcCertTopicId)
      .then((result) => {
        data.submissionDetails = result.data
        this.setState({data: data})
    }).catch((err) => {
        this.setState({ errorMsg: 'Error in Fetching MC Submission details. Please contact Admin' })
      })
  }

  handleuploadClick(evt, certParticipationId, type, fullCertId, mcCertTopicId){
      
  };

  handleBackToMainMC = () => {
    this.props.handleBackToMain()
  }

  render() {
    
    let componentsToShow
    let topicNametoPass = this.props.topicName
    let mcCertTopicIdToPass = this.props.mcCertTopicId
    let i =0
    let templateCheck = 'template'
    let guidelineCheck = 'guideline'

    if(this.state.data.submissionDetails.length>0){
      componentsToShow=<GridCell span="12">
        {this.state.data.submissionDetails.map(function(upload) {
          i++
          if(upload.fileSubType.includes(templateCheck)){
            return(<ExcelTemplateUpload name={upload.name} 
              uploadStatus={upload.uploadStatus} 
              certId={mcCertTopicIdToPass} 
              uploadTypeId={upload.uploadTypeId} 
              certType='MC' 
              artifactURL={upload.artifactUrl} 
              uploadedCertId={upload.certUploadId}
              count={i}/>)
          }
          else if(upload.fileSubType.includes(guidelineCheck)){
            return(<PdfReviewerUpload name={upload.name} 
              uploadStatus={upload.uploadStatus} 
              certId={mcCertTopicIdToPass} 
              uploadTypeId={upload.uploadTypeId} 
              certType='MC' 
              artifactURL={upload.artifactUrl} 
              uploadedCertId={upload.certUploadId}
              count={i}/>)
          }
          else{
            return(<ReviewUpload name={upload.name} 
              uploadStatus={upload.uploadStatus} 
              certId={mcCertTopicIdToPass} 
              uploadTypeId={upload.uploadTypeId} 
              certType='MC' 
              artifactURL={upload.artifactUrl} 
              uploadedCertId={upload.certUploadId}
              count={i}
              />)
          }

        })}
        </GridCell>
    }

    else{

    }

    return (
      <Grid>
        <GridCell span="12">
          <Card style={{padding: '25px'}}>
            <div>
              <Typography use="headline6">Micro Credential Submission - {this.props.topicName}</Typography>
              <Button onClick={this.handleBackToMainMC}><ButtonIcon icon="favorite"/>Back</Button>
            </div>
            <br/>
            {componentsToShow}
          </Card>
        </GridCell>
      </Grid>  
    )
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(MCReviewUpload);



// WEBPACK FOOTER //
// ./src/views/reviewer/MCReviewUpload.jsx